import React, { useEffect, useState } from 'react';
import NavbarDefault from './common/NavbarDefault';
import ContentDefault from './common/ContentDefault';
import { replace } from 'formik';
import { Helmet } from "react-helmet";
import { useLocation } from 'react-router-dom';

export default function Main(props) {
  var time = null;
  const hostName = window.location.host;
  const host = replace(Object.values(hostName), 'calque.com')
  const urlval = useLocation();

  useEffect(() => {
    if (!time) {
      props.timer2();
      time = true;
    }
    return () => props.timer2(urlval);
  }, [props.timer2])

  return (
    <div>
      <Helmet>
        <meta name="title" content="Trade-In Mortgage | Use the equity in your current home to buy your next one" />
        <meta name="description" content="The Trade-In Mortgage™ is a cost effective solution that allows homeowners to submit non-contingent offers as good as cash  and buy and move before they sell." />
        <meta name="keywords" content="trade in mortgage, trade-in mortgage, trade in loan, trade up mortgage, slide loan, slide mortgage, glide loan, trade my home, home swap, mortgage swap, swamp my home, home trade, buy before you sell, buy-first solution, buy-first, Calque, house swap" />
        <meta property="og:title" content="Trade-In Mortgage | Use the equity in your current home to buy your next one" />
        <meta property="og:description" content="The Trade-In Mortgage™ is a cost effective solution that allows homeowners to submit non-contingent offers as good as cash  and buy and move before they sell." />
        <meta property="og:url" content="https://tradeinmortgage.com/" />
        <link rel="canonical" href="https://tradeinmortgage.com/" />
      </Helmet>
      <NavbarDefault {...props} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyMain} addressGlobal={props.addressGlobal} setFaqRealEstateAgentOpen={props.setFaqRealEstateAgentOpen} />
      <ContentDefault {...props} host={host} efficientDefault={props.efficientDefault} setEfficientDefault={props.setEfficientDefault} handleEfficientDefault={props.handleEfficientDefault} contactGlobal={props.contactGlobal} emailGlobal={props.emailGlobal} calendlyUrl={props.calendlyMain} addressGlobal={props.addressGlobal} partner={props.partner} GAtimer={props.GAtimer} GAtimerFinish={props.GAtimerFinish} condition={props.condition} aboutUsList={props.aboutUsList} click_id={props.click_id} gclid={props.gclid} linked_in={props.linked_in} lead_activity_id={props.lead_activity_id} facebook_pixel={props.facebook_pixel} conditionList={props.conditionList} defectsList={props.defectsList}/>
    </div>
  )
}
